import { BaseAmenities, HarAmenities, ToolFilterAmenities } from "types/filters/search-listings-filters";
import { typedEntries } from "./helpers";
import { ToolAmenities } from "types/inputs/search-listings-input";

const generateYearBuiltOptions = (startYear: number, endYear: number) => {
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push({ value: year.toString(), label: year.toString() });
  }
  return years;
};

export const bedroomLookup = [
  { "value": "1", "label": "1 Bed" },
  { "value": "2", "label": "2 Beds" },
  { "value": "3", "label": "3 Beds" },
  { "value": "4", "label": "4 Beds" },
  { "value": "5", "label": "5 Beds" },
  { "value": "6", "label": "6 Beds" },
  { "value": "7", "label": "7 Beds" },
  { "value": "8", "label": "8 Beds" },
  { "value": "9", "label": "9 Beds" }
]

export const bedroomLookupMax = [
  { "value": "1", "label": "1 Bed" },
  { "value": "2", "label": "2 Beds" },
  { "value": "3", "label": "3 Beds" },
  { "value": "4", "label": "4 Beds" },
  { "value": "5", "label": "5 Beds" },
  { "value": "6", "label": "6 Beds" },
  { "value": "7", "label": "7 Beds" },
  { "value": "8", "label": "8 Beds" },
  { "value": "9", "label": "9 Beds" }
]
export const bathroomLookup = [
  { "value": "1", "label": "1 Bath" },
  { "value": "2", "label": "2 Baths" },
  { "value": "3", "label": "3 Baths" },
  { "value": "4", "label": "4 Baths" },
  { "value": "5", "label": "5 Baths" },
  { "value": "6", "label": "6 Baths" },
  { "value": "7", "label": "7 Baths" },
  { "value": "8", "label": "8 Baths" },
  { "value": "9", "label": "9 Baths" }
]
export const bathroomLookupMax = [
  { "value": "1", "label": "1 Bath" },
  { "value": "2", "label": "2 Baths" },
  { "value": "3", "label": "3 Baths" },
  { "value": "4", "label": "4 Baths" },
  { "value": "5", "label": "5 Baths" },
  { "value": "6", "label": "6 Baths" },
  { "value": "7", "label": "7 Baths" },
  { "value": "8", "label": "8 Baths" },
  { "value": "9", "label": "9 Baths" }
]
export const buildingLookup = [
  { "value": "", "label": "Any" },
  { "value": "500", "label": "500" },
  { "value": "750", "label": "750" },
  { "value": "1000", "label": "1,000" },
  { "value": "1250", "label": "1,250" },
  { "value": "1500", "label": "1,500" },
  { "value": "1750", "label": "1,750" },
  { "value": "2000", "label": "2,000" },
  { "value": "2250", "label": "2,250" },
  { "value": "2500", "label": "2,500" },
  { "value": "2750", "label": "2,750" },
  { "value": "3000", "label": "3,000" },
  { "value": "3500", "label": "3,500" },
  { "value": "4000", "label": "4,000" },
  { "value": "4500", "label": "4,500" },
  { "value": "5000", "label": "5,000" },
  { "value": "5500", "label": "5,500" },
  { "value": "6000", "label": "6,000" },
  { "value": "6500", "label": "6,500" },
  { "value": "7000", "label": "7,000" },
  { "value": "7500", "label": "7,500" },
  { "value": "8000", "label": "8,000" },
  { "value": "8500", "label": "8,500" },
  { "value": "9000", "label": "9,000" },
  { "value": "9500", "label": "9,500" },
  { "value": "10000", "label": "10,000" }
]
export const buildingLookupMax = [
  { "value": "500", "label": "500" },
  { "value": "750", "label": "750" },
  { "value": "1000", "label": "1,000" },
  { "value": "1250", "label": "1,250" },
  { "value": "1500", "label": "1,500" },
  { "value": "1750", "label": "1,750" },
  { "value": "2000", "label": "2,000" },
  { "value": "2250", "label": "2,250" },
  { "value": "2500", "label": "2,500" },
  { "value": "2750", "label": "2,750" },
  { "value": "3000", "label": "3,000" },
  { "value": "3500", "label": "3,500" },
  { "value": "4000", "label": "4,000" },
  { "value": "4500", "label": "4,500" },
  { "value": "5000", "label": "5,000" },
  { "value": "5500", "label": "5,500" },
  { "value": "6000", "label": "6,000" },
  { "value": "6500", "label": "6,500" },
  { "value": "7000", "label": "7,000" },
  { "value": "7500", "label": "7,500" },
  { "value": "8000", "label": "8,000" },
  { "value": "8500", "label": "8,500" },
  { "value": "9000", "label": "9,000" },
  { "value": "9500", "label": "9,500" },
  { "value": "10000", "label": "10,000" }
]
export const priceSqt = [
  { "value": "", "label": "No Min" },
  { "value": "30", "label": "$30" },
  { "value": "40", "label": "$40" },
  { "value": "50", "label": "$50" },
  { "value": "55", "label": "$55" },
  { "value": "60", "label": "$60" },
  { "value": "65", "label": "$65" },
  { "value": "70", "label": "$70" },
  { "value": "75", "label": "$75" },
  { "value": "80", "label": "$80" },
  { "value": "85", "label": "$85" },
  { "value": "90", "label": "$90" },
  { "value": "100", "label": "$100" },
  { "value": "110", "label": "$110" },
  { "value": "120", "label": "$120" },
  { "value": "140", "label": "$140" },
  { "value": "160", "label": "$160" },
  { "value": "180", "label": "$180" },
  { "value": "200", "label": "$200" },
  { "value": "300", "label": "$300" },
  { "value": "400", "label": "$400" },
  { "value": "500", "label": "$500" },
  { "value": "600", "label": "$600" },
  { "value": "800", "label": "$800" },
  { "value": "1000", "label": "$1000" },
  { "value": "1200", "label": "$1200" },
  { "value": "1400", "label": "$1400" },
  { "value": "1600", "label": "$1600" },
  { "value": "1800", "label": "$1800" }
]
export const priceSqtMax = [
  { "value": "30", "label": "$30" },
  { "value": "40", "label": "$40" },
  { "value": "50", "label": "$50" },
  { "value": "55", "label": "$55" },
  { "value": "60", "label": "$60" },
  { "value": "65", "label": "$65" },
  { "value": "70", "label": "$70" },
  { "value": "75", "label": "$75" },
  { "value": "80", "label": "$80" },
  { "value": "85", "label": "$85" },
  { "value": "90", "label": "$90" },
  { "value": "100", "label": "$100" },
  { "value": "110", "label": "$110" },
  { "value": "120", "label": "$120" },
  { "value": "140", "label": "$140" },
  { "value": "160", "label": "$160" },
  { "value": "180", "label": "$180" },
  { "value": "200", "label": "$200" },
  { "value": "300", "label": "$300" },
  { "value": "400", "label": "$400" },
  { "value": "500", "label": "$500" },
  { "value": "600", "label": "$600" },
  { "value": "800", "label": "$800" },
  { "value": "1000", "label": "$1000" },
  { "value": "1200", "label": "$1200" },
  { "value": "1400", "label": "$1400" },
  { "value": "1600", "label": "$1600" },
  { "value": "1800", "label": "$1800" },
  { "value": "2000", "label": "$2000" }
]
export const lotSqt = [
  { "value": "", "label": "Any" },
  { "value": "1000", "label": "1,000" },
  { "value": "1500", "label": "1,500" },
  { "value": "2000", "label": "2,000" },
  { "value": "2500", "label": "2,500" },
  { "value": "3000", "label": "3,000" },
  { "value": "3500", "label": "3,500" },
  { "value": "4000", "label": "4,000" },
  { "value": "4500", "label": "4,500" },
  { "value": "5000", "label": "5,000" },
  { "value": "5500", "label": "5,500" },
  { "value": "6000", "label": "6,000" },
  { "value": "6500", "label": "6,500" },
  { "value": "7000", "label": "7,000" },
  { "value": "7500", "label": "7,500" },
  { "value": "8000", "label": "8,000" },
  { "value": "8500", "label": "8,500" },
  { "value": "9000", "label": "9,000" },
  { "value": "9500", "label": "9,500" },
  { "value": "10000", "label": "10,000" },
  { "value": "12500", "label": "12,500" },
  { "value": "15000", "label": "15,000" },
  { "value": "20000", "label": "20,000" },
  { "value": "30000", "label": "30,000" },
  { "value": "50000", "label": "50,000" },
  { "value": "100000", "label": "100,000" },
  { "value": "200000", "label": "200,000" },
  { "value": "300000", "label": "300,000" },
  { "value": "400000", "label": "400,000" },
  { "value": "500000", "label": "500,000" }
]
export const lotSqtMax = [
  { "value": "1000", "label": "1,000" },
  { "value": "1500", "label": "1,500" },
  { "value": "2000", "label": "2,000" },
  { "value": "2500", "label": "2,500" },
  { "value": "3000", "label": "3,000" },
  { "value": "3500", "label": "3,500" },
  { "value": "4000", "label": "4,000" },
  { "value": "4500", "label": "4,500" },
  { "value": "5000", "label": "5,000" },
  { "value": "5500", "label": "5,500" },
  { "value": "6000", "label": "6,000" },
  { "value": "6500", "label": "6,500" },
  { "value": "7000", "label": "7,000" },
  { "value": "7500", "label": "7,500" },
  { "value": "8000", "label": "8,000" },
  { "value": "8500", "label": "8,500" },
  { "value": "9000", "label": "9,000" },
  { "value": "9500", "label": "9,500" },
  { "value": "10000", "label": "10,000" },
  { "value": "12500", "label": "12,500" },
  { "value": "15000", "label": "15,000" },
  { "value": "20000", "label": "20,000" },
  { "value": "30000", "label": "30,000" },
  { "value": "50000", "label": "50,000" },
  { "value": "100000", "label": "100,000" },
  { "value": "200000", "label": "200,000" },
  { "value": "300000", "label": "300,000" },
  { "value": "400000", "label": "400,000" },
  { "value": "500000", "label": "500,000" }
]
export const lotAcr = [
  { "value": "", "label": "Any" },
  { "value": "0.25", "label": "1/4 Acre" },
  { "value": "0.5", "label": "1/2 Acre" },
  { "value": "0.75", "label": "3/4 Acre" },
  { "value": "1", "label": "1 Acre" },
  { "value": "2", "label": "2 Acres" },
  { "value": "3", "label": "3 Acres" },
  { "value": "4", "label": "4 Acres" },
  { "value": "5", "label": "5 Acres" },
  { "value": "10", "label": "10 Acres" },
  { "value": "15", "label": "15 Acres" },
  { "value": "20", "label": "20 Acres" },
  { "value": "30", "label": "30 Acres" },
  { "value": "40", "label": "40 Acres" },
  { "value": "50", "label": "50 Acres" },
  { "value": "100", "label": "100 Acres" },
  { "value": "250", "label": "250 Acres" },
  { "value": "500", "label": "500 Acres" }
]
export const lotAcrMax = [
  { "value": "0.25", "label": "1/4 Acre" },
  { "value": "0.5", "label": "1/2 Acre" },
  { "value": "0.75", "label": "3/4 Acre" },
  { "value": "1", "label": "1 Acre" },
  { "value": "2", "label": "2 Acres" },
  { "value": "3", "label": "3 Acres" },
  { "value": "4", "label": "4 Acres" },
  { "value": "5", "label": "5 Acres" },
  { "value": "10", "label": "10 Acres" },
  { "value": "15", "label": "15 Acres" },
  { "value": "20", "label": "20 Acres" },
  { "value": "30", "label": "30 Acres" },
  { "value": "40", "label": "40 Acres" },
  { "value": "50", "label": "50 Acres" },
  { "value": "100", "label": "100 Acres" },
  { "value": "250", "label": "250 Acres" },
  { "value": "500", "label": "500 Acres" },
  { "value": "1000", "label": "1000 Acres" }
]
export const garageLookup = [
  { "value": "", "label": "No Min" },
  { "value": "1", "label": "1+" },
  { "value": "2", "label": "2+" },
  { "value": "3", "label": "3+" },
  { "value": "4", "label": "4+" },
  { "value": "5", "label": "5+" }
]
export const garageLookupMax = [
  { "value": "", "label": "(All)" },
  { "value": "Attached", "label": "Attached" },
  { "value": "Detached", "label": "Detached" },
  { "value": "Oversized", "label": "Oversized" },
  { "value": "Attached/Detached", "label": "Attached/Detached" },
  { "value": "Tandem", "label": "Tandem" }
]

export const yearBuild = generateYearBuiltOptions(1900, new Date().getFullYear());

export const storiesLookup = [
  { value: "1", label: "1" },
  { value: "1.5", label: "1.5" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
];
export const styleLookup = [
  { value: "", label: "Please Select" },
  { value: "Colonial", label: "Colonial" },
  { value: "Contemporary", label: "Contemporary" },
  { value: "Contemporary/Modern", label: "Contemporary/Modern" },
  { value: "English", label: "English" },
  { value: "French", label: "French" },
  { value: "Georgian", label: "Georgian" },
  { value: "Ranch", label: "Ranch" },
  { value: "Mediterranean", label: "Mediterranean" },
  { value: "Spanish", label: "Spanish" },
  { value: "Split Level", label: "Split Level" },
  { value: "Traditional", label: "Traditional" },
  { value: "Victorian", label: "Victorian" },
];
export const constructionLookup = [
  { value: "", label: "Please Select" },
  { value: "Y", label: "All New / Recent Construction" },
  { value: "Never Lived In", label: "Completed but never lived in" },
  { value: "To Be Built/Under Construction", label: "Unfinished - Under Construction" },
];
// Drive-time selects, mirroring har.com's own (idxDOSearch / the search-filter
// panel): travel time in minutes, arrival time as 24h "HH:MM" in half-hour
// steps. The values are what the backend expects on the wire.
export const driveTimeTravelTimeOptions = [
  { value: "", label: "Select Travel Time" },
  ...[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 75, 90].map((minutes) => ({
    value: String(minutes),
    label: `${minutes} Minutes`,
  })),
];

// 05:00 first, like the site: the day starts where commutes do, and the small
// hours sit at the end of the list.
export const driveTimeArrivalTimeOptions = [
  { value: "", label: "Select Arrival Time" },
  ...Array.from({ length: 48 }, (_, slot) => {
    const minutesOfDay = ((slot + 10) * 30) % (24 * 60);
    const hours24 = Math.floor(minutesOfDay / 60);
    const minutes = minutesOfDay % 60;
    const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;
    const meridiem = hours24 < 12 ? "am" : "pm";
    return {
      value: `${String(hours24).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`,
      label: `${hours12}:${String(minutes).padStart(2, "0")} ${meridiem}`,
    };
  }),
];

export const parkingSpacesOptions = [
  { value: "", label: "Please Select" },
  { value: "1", label: "1+ Parking Space(s)" },
  { value: "2", label: "2+ Parking Spaces" },
  { value: "3", label: "3+ Parking Spaces" },
  { value: "4", label: "4+ Parking Spaces" },
];
// Mirrors the `finance` field of HAR.com's for-sale search form, GET /form/1
// (`data.value` / `data.label`, in order). That endpoint is the source of truth
// for both the values HAR matches and the labels it shows; check it against this
// list when a finance filter looks wrong in the UI.
//
// A value HAR has added is not an error here and raises nothing: the search
// still applies, `getLongValue` just finds no label for it. What you see is the
// pill falling back to the raw code instead of the human label (FilterPills'
// Finance entry passes the value as `getLongValue`'s default) and the
// `[name=Finance]` <select> matching no <option>, so the dropdown reads as
// unset. Both are quiet — nothing points at this list being stale.
export const financeOptions = [
  { value: "", label: "-- Select Finance Option --" },
  { value: "Owner Financing", label: "Owner Financing" },
  // HAR matches `finance` as a SUBSTRING of the listing's financing text, which
  // reads "Seller May Contribute to Buyer's Closing Costs". The value below is
  // the one HAR.com's own search URL sends; the former "Seller to Contribute..."
  // is not a substring of anything and returned 0 listings. See CB-1764.
  { value: "Contribute to Buyer's Closing Costs", label: "Seller May Contribute to Buyer's Closing Costs" },
  { value: "Lease/Purchase", label: "Lease/Purchase" },
  { value: "Affordable Housing Program", label: "Affordable Housing Program" },
  { value: "FHA", label: "FHA" },
  { value: "VA", label: "VA" },
  { value: "Conventional", label: "Conventional" },
  // Added by HAR after this list was first written. The value is the bare code,
  // not the label: `finance` is matched as a substring, so "USDA Loan" is the
  // narrower term and would silently return fewer listings than "USDA".
  { value: "USDA", label: "USDA Loan" },
];

/**
 * `finance` reaches the UI in shapes that do not match `financeOptions` exactly:
 * the apostrophe may be percent-encoded (`Buyer%27s`) or curly, and older
 * sessions and artifacts carry the pre-CB-1764 closing-costs value. Every
 * consumer matches by strict equality — `getLongValue` in FilterPills and the
 * controlled `<select name="Finance">` in the Filters panel — so an unmatched
 * variant rendered no pill at all and left the dropdown looking unset while the
 * filter was in fact applied.
 *
 * NOTE: the normalized value is also what goes on the wire to HAR, so an entry
 * here must be a string HAR actually accepts — see the substring note on
 * `financeOptions` above.
 */
const FINANCE_VALUE_ALIASES = new Map<string, string>([
  // The value this option carried before CB-1764. Not a substring of HAR's
  // financing text, so it searched for nothing and returned 0 listings.
  ["seller to contribute to buyer's closing costs", "Contribute to Buyer's Closing Costs"],
]);

/** Percent-decode, straighten curly apostrophes and collapse whitespace. */
const cleanFinanceValue = (value: string): string => {
  let cleaned = value;
  try {
    cleaned = decodeURIComponent(cleaned);
  } catch {
    // A lone `%` makes decodeURIComponent throw; keep the raw value instead.
  }
  return cleaned.replace(/[\u2018\u2019]/g, "'").replace(/\s+/g, " ").trim();
};

// Cleaned+lowercased value AND label -> canonical value, so an incoming display
// name ("Seller May Contribute to Buyer's Closing Costs") resolves too. A Map
// rather than a record: the keys are external input.
const FINANCE_CANONICAL_BY_KEY = financeOptions.reduce((acc, { value, label }) => {
  if (!value) return acc; // skip the "-- Select Finance Option --" placeholder
  acc.set(cleanFinanceValue(value).toLowerCase(), value);
  acc.set(cleanFinanceValue(label).toLowerCase(), value);
  return acc;
}, new Map<string, string>());

/**
 * Resolve any incoming `finance` value to the canonical `financeOptions` value.
 * Falls back to the cleaned input when nothing matches, so an unknown future HAR
 * value at least renders readably instead of showing `%27`.
 */
export const normalizeFinanceValue = (value?: string): string | undefined => {
  if (!value) return undefined;
  const cleaned = cleanFinanceValue(value);
  if (!cleaned) return undefined;
  const key = cleaned.toLowerCase();
  return FINANCE_CANONICAL_BY_KEY.get(key) ?? FINANCE_VALUE_ALIASES.get(key) ?? cleaned;
};

export const maintenanceFeeOptions = [
  { value: "", label: "Any" },
  { value: "0", label: "No HOA Fee" },
  { value: "10", label: "$10 /month ($120 /year)" },
  { value: "20", label: "$20 /month ($240 /year)" },
  { value: "30", label: "$30 /month ($360 /year)" },
  { value: "40", label: "$40 /month ($480 /year)" },
  { value: "50", label: "$50 /month ($600 /year)" },
  { value: "60", label: "$60 /month ($720 /year)" },
  { value: "70", label: "$70 /month ($840 /year)" },
  { value: "80", label: "$80 /month ($960 /year)" },
  { value: "90", label: "$90 /month ($1080 /year)" },
  { value: "100", label: "$100 /month ($1200 /year)" },
  { value: "125", label: "$125 /month ($1500 /year)" },
  { value: "150", label: "$150 /month ($1800 /year)" },
  { value: "175", label: "$175 /month ($2100 /year)" },
  { value: "200", label: "$200 /month ($2400 /year)" },
  { value: "250", label: "$250 /month ($3000 /year)" },
  { value: "300", label: "$300 /month ($3600 /year)" },
  { value: "400", label: "$400 /month ($4800 /year)" },
  { value: "500", label: "$500 /month ($6000 /year)" },
  { value: "600", label: "$600 /month ($7200 /year)" },
  { value: "700", label: "$700 /month ($8400 /year)" },
  { value: "800", label: "$800 /month ($9600 /year)" },
  { value: "900", label: "$900 /month ($10800 /year)" },
  { value: "1000", label: "$1000 /month ($12000 /year)" },
  { value: "1200", label: "$1200 /month ($14400 /year)" },
  { value: "1400", label: "$1400 /month ($16800 /year)" },
  { value: "1600", label: "$1600 /month ($19200 /year)" },
  { value: "1800", label: "$1800 /month ($21600 /year)" },
  { value: "2000", label: "$2000 /month ($24000 /year)" },
  { value: "2500", label: "$2500 /month ($30000 /year)" },
];

export const countiesLookup = [
  { value: "", label: "Select County" },
  { value: "48001", label: "Anderson" },
  { value: "48003", label: "Andrews" },
  { value: "48005", label: "Angelina" },
  { value: "48007", label: "Aransas" },
  { value: "48009", label: "Archer" },
  { value: "48011", label: "Armstrong" },
  { value: "48013", label: "Atascosa" },
  { value: "48015", label: "Austin" },
  { value: "48017", label: "Bailey" },
  { value: "48019", label: "Bandera" },
  { value: "48021", label: "Bastrop" },
  { value: "48023", label: "Baylor" },
  { value: "48025", label: "Bee" },
  { value: "48027", label: "Bell" },
  { value: "48029", label: "Bexar" },
  { value: "48031", label: "Blanco" },
  { value: "48033", label: "Borden" },
  { value: "48035", label: "Bosque" },
  { value: "48037", label: "Bowie" },
  { value: "48039", label: "Brazoria" },
  { value: "48041", label: "Brazos" },
  { value: "48043", label: "Brewster" },
  { value: "48045", label: "Briscoe" },
  { value: "48047", label: "Brooks" },
  { value: "48049", label: "Brown" },
  { value: "48051", label: "Burleson" },
  { value: "48053", label: "Burnet" },
  { value: "48055", label: "Caldwell" },
  { value: "48057", label: "Calhoun" },
  { value: "48059", label: "Callahan" },
  { value: "48061", label: "Cameron" },
  { value: "48063", label: "Camp" },
  { value: "48065", label: "Carson" },
  { value: "48067", label: "Cass" },
  { value: "48069", label: "Castro" },
  { value: "48071", label: "Chambers" },
  { value: "48073", label: "Cherokee" },
  { value: "48075", label: "Childress" },
  { value: "48077", label: "Clay" },
  { value: "48079", label: "Cochran" },
  { value: "48081", label: "Coke" },
  { value: "48083", label: "Coleman" },
  { value: "48085", label: "Collin" },
  { value: "48087", label: "Collingsworth" },
  { value: "48089", label: "Colorado" },
  { value: "48091", label: "Comal" },
  { value: "48093", label: "Comanche" },
  { value: "48095", label: "Concho" },
  { value: "48097", label: "Cooke" },
  { value: "48099", label: "Coryell" },
  { value: "48101", label: "Cottle" },
  { value: "48103", label: "Crane" },
  { value: "48105", label: "Crockett" },
  { value: "48107", label: "Crosby" },
  { value: "48109", label: "Culberson" },
  { value: "48111", label: "Dallam" },
  { value: "48113", label: "Dallas" },
  { value: "48115", label: "Dawson" },
  { value: "48117", label: "Deaf Smith" },
  { value: "48119", label: "Delta" },
  { value: "48121", label: "Denton" },
  { value: "48123", label: "DeWitt" },
  { value: "48125", label: "Dickens" },
  { value: "48127", label: "Dimmit" },
  { value: "48129", label: "Donley" },
  { value: "48131", label: "Duval" },
  { value: "48133", label: "Eastland" },
  { value: "48135", label: "Ector" },
  { value: "48137", label: "Edwards" },
  { value: "48141", label: "El Paso" },
  { value: "48139", label: "Ellis" },
  { value: "48143", label: "Erath" },
  { value: "48145", label: "Falls" },
  { value: "48147", label: "Fannin" },
  { value: "48149", label: "Fayette" },
  { value: "48151", label: "Fisher" },
  { value: "48153", label: "Floyd" },
  { value: "48155", label: "Foard" },
  { value: "48157", label: "Fort Bend" },
  { value: "48159", label: "Franklin" },
  { value: "48161", label: "Freestone" },
  { value: "48163", label: "Frio" },
  { value: "48165", label: "Gaines" },
  { value: "48167", label: "Galveston" },
  { value: "48169", label: "Garza" },
  { value: "48171", label: "Gillespie" },
  { value: "48173", label: "Glasscock" },
  { value: "48175", label: "Goliad" },
  { value: "48177", label: "Gonzales" },
  { value: "48179", label: "Gray" },
  { value: "48181", label: "Grayson" },
  { value: "48183", label: "Gregg" },
  { value: "48185", label: "Grimes" },
  { value: "48187", label: "Guadalupe" },
  { value: "48189", label: "Hale" },
  { value: "48191", label: "Hall" },
  { value: "48193", label: "Hamilton" },
  { value: "48195", label: "Hansford" },
  { value: "48197", label: "Hardeman" },
  { value: "48199", label: "Hardin" },
  { value: "48201", label: "Harris" },
  { value: "48203", label: "Harrison" },
  { value: "48205", label: "Hartley" },
  { value: "48207", label: "Haskell" },
  { value: "48209", label: "Hays" },
  { value: "48211", label: "Hemphill" },
  { value: "48213", label: "Henderson" },
  { value: "48215", label: "Hidalgo" },
  { value: "48217", label: "Hill" },
  { value: "48219", label: "Hockley" },
  { value: "48221", label: "Hood" },
  { value: "48223", label: "Hopkins" },
  { value: "48225", label: "Houston" },
  { value: "48227", label: "Howard" },
  { value: "48229", label: "Hudspeth" },
  { value: "48231", label: "Hunt" },
  { value: "48233", label: "Hutchinson" },
  { value: "48235", label: "Irion" },
  { value: "48237", label: "Jack" },
  { value: "48239", label: "Jackson" },
  { value: "48241", label: "Jasper" },
  { value: "48243", label: "Jeff Davis" },
  { value: "48245", label: "Jefferson" },
  { value: "48247", label: "Jim Hogg" },
  { value: "48249", label: "Jim Wells" },
  { value: "48251", label: "Johnson" },
  { value: "48253", label: "Jones" },
  { value: "48255", label: "Karnes" },
  { value: "48257", label: "Kaufman" },
  { value: "48259", label: "Kendall" },
  { value: "48261", label: "Kenedy" },
  { value: "48263", label: "Kent" },
  { value: "48265", label: "Kerr" },
  { value: "48267", label: "Kimble" },
  { value: "48269", label: "King" },
  { value: "48271", label: "Kinney" },
  { value: "48273", label: "Kleberg" },
  { value: "48275", label: "Knox" },
  { value: "48283", label: "La Salle" },
  { value: "48277", label: "Lamar" },
  { value: "48279", label: "Lamb" },
  { value: "48281", label: "Lampasas" },
  { value: "48285", label: "Lavaca" },
  { value: "48287", label: "Lee" },
  { value: "48289", label: "Leon" },
  { value: "48291", label: "Liberty" },
  { value: "48293", label: "Limestone" },
  { value: "48295", label: "Lipscomb" },
  { value: "48297", label: "Live Oak" },
  { value: "48299", label: "Llano" },
  { value: "48301", label: "Loving" },
  { value: "48303", label: "Lubbock" },
  { value: "48305", label: "Lynn" },
  { value: "48313", label: "Madison" },
  { value: "48315", label: "Marion" },
  { value: "48317", label: "Martin" },
  { value: "48319", label: "Mason" },
  { value: "48321", label: "Matagorda" },
  { value: "48323", label: "Maverick" },
  { value: "48307", label: "McCulloch" },
  { value: "48309", label: "McLennan" },
  { value: "48311", label: "McMullen" },
  { value: "48325", label: "Medina" },
  { value: "48327", label: "Menard" },
  { value: "48329", label: "Midland" },
  { value: "48331", label: "Milam" },
  { value: "48333", label: "Mills" },
  { value: "48335", label: "Mitchell" },
  { value: "48337", label: "Montague" },
  { value: "48339", label: "Montgomery" },
  { value: "48341", label: "Moore" },
  { value: "48343", label: "Morris" },
  { value: "48345", label: "Motley" },
  { value: "48347", label: "Nacogdoches" },
  { value: "48349", label: "Navarro" },
  { value: "48351", label: "Newton" },
  { value: "48353", label: "Nolan" },
  { value: "48355", label: "Nueces" },
  { value: "48357", label: "Ochiltree" },
  { value: "48359", label: "Oldham" },
  { value: "48361", label: "Orange" },
  { value: "48363", label: "Palo Pinto" },
  { value: "48365", label: "Panola" },
  { value: "48367", label: "Parker" },
  { value: "48369", label: "Parmer" },
  { value: "48371", label: "Pecos" },
  { value: "48373", label: "Polk" },
  { value: "48375", label: "Potter" },
  { value: "48377", label: "Presidio" },
  { value: "48379", label: "Rains" },
  { value: "48381", label: "Randall" },
  { value: "48383", label: "Reagan" },
  { value: "48385", label: "Real" },
  { value: "48387", label: "Red River" },
  { value: "48389", label: "Reeves" },
  { value: "48391", label: "Refugio" },
  { value: "48393", label: "Roberts" },
  { value: "48395", label: "Robertson" },
  { value: "48397", label: "Rockwall" },
  { value: "48399", label: "Runnels" },
  { value: "48401", label: "Rusk" },
  { value: "48403", label: "Sabine" },
  { value: "48405", label: "San Augustine" },
  { value: "48407", label: "San Jacinto" },
  { value: "48409", label: "San Patricio" },
  { value: "48411", label: "San Saba" },
  { value: "48413", label: "Schleicher" },
  { value: "48415", label: "Scurry" },
  { value: "48417", label: "Shackelford" },
  { value: "48419", label: "Shelby" },
  { value: "48421", label: "Sherman" },
  { value: "48423", label: "Smith" },
  { value: "48425", label: "Somervell" },
  { value: "48427", label: "Starr" },
  { value: "48429", label: "Stephens" },
  { value: "48431", label: "Sterling" },
  { value: "48433", label: "Stonewall" },
  { value: "48435", label: "Sutton" },
  { value: "48437", label: "Swisher" },
  { value: "48439", label: "Tarrant" },
  { value: "48441", label: "Taylor" },
  { value: "48443", label: "Terrell" },
  { value: "48445", label: "Terry" },
  { value: "48447", label: "Throckmorton" },
  { value: "48449", label: "Titus" },
  { value: "48451", label: "Tom Green" },
  { value: "48453", label: "Travis" },
  { value: "48455", label: "Trinity" },
  { value: "48457", label: "Tyler" },
  { value: "48459", label: "Upshur" },
  { value: "48461", label: "Upton" },
  { value: "48463", label: "Uvalde" },
  { value: "48465", label: "Val Verde" },
  { value: "48467", label: "Van Zandt" },
  { value: "48469", label: "Victoria" },
  { value: "48471", label: "Walker" },
  { value: "48473", label: "Waller" },
  { value: "48475", label: "Ward" },
  { value: "48477", label: "Washington" },
  { value: "48479", label: "Webb" },
  { value: "48481", label: "Wharton" },
  { value: "48483", label: "Wheeler" },
  { value: "48485", label: "Wichita" },
  { value: "48487", label: "Wilbarger" },
  { value: "48489", label: "Willacy" },
  { value: "48491", label: "Williamson" },
  { value: "48493", label: "Wilson" },
  { value: "48495", label: "Winkler" },
  { value: "48497", label: "Wise" },
  { value: "48499", label: "Wood" },
  { value: "48501", label: "Yoakum" },
  { value: "48503", label: "Young" },
  { value: "48505", label: "Zapata" },
  { value: "48507", label: "Zavala" },
];

export const areas = [
  { value: "", label: "All Areas" },
  { value: "1960/Cypress", label: "1960/Cypress" },
  { value: "1960/Cypress Creek North", label: "1960/Cypress Creek North" },
  { value: "1960/Cypress Creek South", label: "1960/Cypress Creek South" },
  { value: "Aldine Area", label: "Aldine Area" },
  { value: "Alief", label: "Alief" },
  { value: "Alvin North", label: "Alvin North" },
  { value: "Alvin South", label: "Alvin South" },
  { value: "Angelina County", label: "Angelina County" },
  { value: "Angleton", label: "Angleton" },
  { value: "Atascocita North", label: "Atascocita North" },
  { value: "Atascocita South", label: "Atascocita South" },
  { value: "Bacliff/San Leon", label: "Bacliff/San Leon" },
  { value: "Bayou Vista", label: "Bayou Vista" },
  { value: "Baytown/Chambers County", label: "Baytown/Chambers County" },
  { value: "Baytown/Harris County", label: "Baytown/Harris County" },
  { value: "Bear Creek South", label: "Bear Creek South" },
  { value: "Bellaire Area", label: "Bellaire Area" },
  { value: "Braeswood Place", label: "Braeswood Place" },
  { value: "Brays Oaks", label: "Brays Oaks" },
  { value: "Briar Hollow", label: "Briar Hollow" },
  { value: "Briargrove", label: "Briargrove" },
  { value: "Briargrove Park/Walnutbend", label: "Briargrove Park/Walnutbend" },
  { value: "Briarmeadow/Tanglewilde", label: "Briarmeadow/Tanglewilde" },
  { value: "Brookshire", label: "Brookshire" },
  { value: "Caplen", label: "Caplen" },
  { value: "Chambers County East", label: "Chambers County East" },
  { value: "Chambers County West", label: "Chambers County West" },
  { value: "Champions Area", label: "Champions Area" },
  { value: "Charnwood/Briarbend", label: "Charnwood/Briarbend" },
  { value: "Clear Lake Area", label: "Clear Lake Area" },
  { value: "Cleveland Area", label: "Cleveland Area" },
  { value: "Clute", label: "Clute" },
  { value: "Coldspring/South San Jacinto County", label: "Coldspring/South San Jacinto County" },
  { value: "Conroe Northeast", label: "Conroe Northeast" },
  { value: "Conroe Southeast", label: "Conroe Southeast" },
  { value: "Conroe Southwest", label: "Conroe Southwest" },
  { value: "Copperfield Area", label: "Copperfield Area" },
  { value: "Cottage Grove", label: "Cottage Grove" },
  { value: "Crosby Area", label: "Crosby Area" },
  { value: "Crystal Beach", label: "Crystal Beach" },
  { value: "Cypress North", label: "Cypress North" },
  { value: "Cypress South", label: "Cypress South" },
  { value: "Danbury", label: "Danbury" },
  { value: "Dayton", label: "Dayton" },
  { value: "Deer Park", label: "Deer Park" },
  { value: "Denver Harbor", label: "Denver Harbor" },
  { value: "Dickinson", label: "Dickinson" },
  { value: "Downtown - Houston", label: "Downtown - Houston" },
  { value: "Downtown -Galveston/The Strand", label: "Downtown -Galveston/The Strand" },
  { value: "East Beach", label: "East Beach" },
  { value: "East End", label: "East End" },
  { value: "East End Revitalized", label: "East End Revitalized" },
  { value: "Eldridge North", label: "Eldridge North" },
  { value: "Energy Corridor", label: "Energy Corridor" },
  { value: "Fall Creek Area", label: "Fall Creek Area" },
  { value: "Five Corners", label: "Five Corners" },
  { value: "Fort Bend County North/Richmond", label: "Fort Bend County North/Richmond" },
  { value: "Fort Bend South/Richmond", label: "Fort Bend South/Richmond" },
  { value: "Fort Bend Southeast", label: "Fort Bend Southeast" },
  { value: "Freeport", label: "Freeport" },
  { value: "Friendswood", label: "Friendswood" },
  { value: "Fulshear/South Brookshire/Simonton", label: "Fulshear/South Brookshire/Simonton" },
  { value: "Galleria", label: "Galleria" },
  { value: "Garden Oaks", label: "Garden Oaks" },
  { value: "Gilchrist", label: "Gilchrist" },
  { value: "Greenway Plaza", label: "Greenway Plaza" },
  { value: "Gulfton", label: "Gulfton" },
  { value: "Harborside", label: "Harborside" },
  { value: "Harborwalk", label: "Harborwalk" },
  { value: "Heights/Greater Heights", label: "Heights/Greater Heights" },
  { value: "Hempstead", label: "Hempstead" },
  { value: "High Island", label: "High Island" },
  { value: "Highland Bayou", label: "Highland Bayou" },
  { value: "Highland Village/Midlane", label: "Highland Village/Midlane" },
  { value: "Hitchcock", label: "Hitchcock" },
  { value: "Hobby Area", label: "Hobby Area" },
  { value: "Hockley", label: "Hockley" },
  { value: "Huffman Area", label: "Huffman Area" },
  { value: "Humble Area East", label: "Humble Area East" },
  { value: "Humble Area South", label: "Humble Area South" },
  { value: "Humble Area West", label: "Humble Area West" },
  { value: "Jersey Village", label: "Jersey Village" },
  { value: "Katy - North", label: "Katy - North" },
  { value: "Katy - Old Towne", label: "Katy - Old Towne" },
  { value: "Katy - Southeast", label: "Katy - Southeast" },
  { value: "Katy - Southwest", label: "Katy - Southwest" },
  { value: "Kingwood East", label: "Kingwood East" },
  { value: "Kingwood NW/Oakhurst", label: "Kingwood NW/Oakhurst" },
  { value: "Kingwood South", label: "Kingwood South" },
  { value: "Kingwood West", label: "Kingwood West" },
  { value: "Knollwood/Woodside Area", label: "Knollwood/Woodside Area" },
  { value: "La Marque", label: "La Marque" },
  { value: "La Porte/Shoreacres", label: "La Porte/Shoreacres" },
  { value: "Lake Conroe Area", label: "Lake Conroe Area" },
  { value: "Lake Jackson", label: "Lake Jackson" },
  { value: "Lake Livingston Area", label: "Lake Livingston Area" },
  { value: "League City", label: "League City" },
  { value: "Liberty", label: "Liberty" },
  { value: "Liberty County East", label: "Liberty County East" },
  { value: "Livingston Area", label: "Livingston Area" },
  { value: "Lomax Area", label: "Lomax Area" },
  { value: "Magnolia/1488 East", label: "Magnolia/1488 East" },
  { value: "Magnolia/1488 West", label: "Magnolia/1488 West" },
  { value: "Medical Center Area", label: "Medical Center Area" },
  { value: "Medical Center South", label: "Medical Center South" },
  { value: "Memorial Close In", label: "Memorial Close In" },
  { value: "Memorial Park", label: "Memorial Park" },
  { value: "Memorial Villages", label: "Memorial Villages" },
  { value: "Memorial West", label: "Memorial West" },
  { value: "Meyerland Area", label: "Meyerland Area" },
  { value: "Midtown - Galveston", label: "Midtown - Galveston" },
  { value: "Midtown - Houston", label: "Midtown - Houston" },
  { value: "Mission Bend Area", label: "Mission Bend Area" },
  { value: "Missouri City Area", label: "Missouri City Area" },
  { value: "Montgomery County Northwest", label: "Montgomery County Northwest" },
  { value: "Montrose", label: "Montrose" },
  { value: "Near West End", label: "Near West End" },
  { value: "New Wavery Area", label: "New Waverly Area" },
  { value: "North Channel", label: "North Channel" },
  { value: "Northeast Houston", label: "Northeast Houston" },
  { value: "Northside", label: "Northside" },
  { value: "Northwest Houston", label: "Northwest Houston" },
  { value: "Oak Forest East Area", label: "Oak Forest East Area" },
  { value: "Oak Forest West Area", label: "Oak Forest West Area" },
  { value: "Omega Bay", label: "Omega Bay" },
  { value: "Other", label: "Other" },
  { value: "Pasadena", label: "Pasadena" },
  { value: "Pearland", label: "Pearland" },
  { value: "Plantersville Area", label: "Plantersville Area" },
  { value: "Polk County North", label: "Polk County North" },
  { value: "Port Bolivar", label: "Port Bolivar" },
  { value: "Porter/New Caney East", label: "Porter/New Caney East" },
  { value: "Porter/New Caney West", label: "Porter/New Caney West" },
  { value: "Rice Military/Washington Corridor", label: "Rice Military/Washington Corridor" },
  { value: "Rice/Museum District", label: "Rice/Museum District" },
  { value: "Richwood", label: "Richwood" },
  { value: "River Oaks Area", label: "River Oaks Area" },
  { value: "River Oaks Shopping Area", label: "River Oaks Shopping Area" },
  { value: "Rivercrest", label: "Rivercrest" },
  { value: "Riverside", label: "Riverside" },
  { value: "Rosharon", label: "Rosharon" },
  { value: "Royden Oaks/Afton Oaks", label: "Royden Oaks/Afton Oaks" },
  { value: "Santa Fe", label: "Santa Fe" },
  { value: "Sharpstown Area", label: "Sharpstown Area" },
  { value: "Shepherd Park Plaza Area", label: "Shepherd Park Plaza Area" },
  { value: "Shoreacres/La Porte", label: "Shoreacres/La Porte" },
  { value: "Sienna Area", label: "Sienna Area" },
  { value: "South Houston", label: "South Houston" },
  { value: "Southbelt/Ellington", label: "Southbelt/Ellington" },
  { value: "Spring Branch", label: "Spring Branch" },
  { value: "Spring East", label: "Spring East" },
  { value: "Spring Northeast", label: "Spring Northeast" },
  { value: "Spring/Klein", label: "Spring/Klein" },
  { value: "Spring/Klein/Tomball", label: "Spring/Klein/Tomball" },
  { value: "Stafford Area", label: "Stafford Area" },
  { value: "Sugar Land East", label: "Sugar Land East" },
  { value: "Sugar Land North", label: "Sugar Land North" },
  { value: "Sugar Land South", label: "Sugar Land South" },
  { value: "Sugar Land West", label: "Sugar Land West" },
  { value: "Summerwood/Lakeshore", label: "Summerwood/Lakeshore" },
  { value: "Surfside", label: "Surfside" },
  { value: "Tanglewood Area", label: "Tanglewood Area" },
  { value: "Teichman/Channelview Area", label: "Teichman/Channelview Area" },
  { value: "Texas City", label: "Texas City" },
  { value: "Tiki Island", label: "Tiki Island" },
  { value: "Timbergrove/Lazybrook", label: "Timbergrove/Lazybrook" },
  { value: "Tomball", label: "Tomball" },
  { value: "Tomball South/Lakewood", label: "Tomball South/Lakewood" },
  { value: "Tomball Southwest", label: "Tomball Southwest" },
  { value: "Treasure Island", label: "Treasure Island" },
  { value: "Trinity Area", label: "Trinity Area" },
  { value: "Tyler County", label: "Tyler County" },
  { value: "University Area", label: "University Area" },
  { value: "Upper Kirby", label: "Upper Kirby" },
  { value: "Waller", label: "Waller" },
  { value: "Washington East/Sabine", label: "Washington East/Sabine" },
  { value: "Webster", label: "Webster" },
  { value: "West End", label: "West End" },
  { value: "West of the Brazos", label: "West of the Brazos" },
  { value: "West University/Southside Area", label: "West University/Southside Area" },
  { value: "Westchase Area", label: "Westchase Area" },
  { value: "Willis Area", label: "Willis Area" },
  { value: "Willow Meadows Area", label: "Willow Meadows Area" },
  { value: "Willowbrook South", label: "Willowbrook South" },
  { value: "Winrock", label: "Winrock" },
  { value: "The Woodlands", label: "The Woodlands" },

];
export const mlsAreas = [
  { value: "", label: "All MLS Areas" },
  { value: "1", label: "1 - Northeast" },
  { value: "2", label: "2 - East" },
  { value: "3", label: "3 - Southeast" },
  { value: "4", label: "4 - South" },
  { value: "5", label: "5 - Brazoria County" },
  { value: "6", label: "6 - Pasadena Area" },
  { value: "7", label: "7 - Clear Lake Area" },
  { value: "8", label: "8 - Hwy 6 North" },
  { value: "9", label: "9 - Central North" },
  { value: "10", label: "10 - Cy-Fair" },
  { value: "11", label: "11 - Near North" },
  { value: "12", label: "12 - North" },
  { value: "13", label: "13 - Northwest" },
  { value: "14", label: "14 - Far Northwest" },
  { value: "15", label: "15 - Montgomery County SW" },
  { value: "16", label: "16 - Central" },
  { value: "17", label: "17 - Southwest" },
  { value: "18", label: "18 - South Central" },
  { value: "19", label: "19 - Montgomery County NE" },
  { value: "20", label: "20 - Bellaire South" },
  { value: "21", label: "21 - Bellaire West" },
  { value: "22", label: "22 - Central West" },
  { value: "23", label: "23 - Memorial" },
  { value: "24", label: "24 - Spring Branch" },
  { value: "25", label: "25 - Far West" },
  { value: "26", label: "26 - Waller County" },
  { value: "28", label: "28 - Alief Area" },
  { value: "29", label: "29 - Ft. Bend Central" },
  { value: "30", label: "30 - Ft. Bend Southwest" },
  { value: "31", label: "31 - West" },
  { value: "32", label: "32 - Far Northeast" },
  { value: "33", label: "33 - Galveston County" },
  { value: "34", label: "34 - Aldine-Westfield Area" },
  { value: "35", label: "35 - Tomball/Cypress" },
  { value: "36", label: "36 - South Katy Area" },
  { value: "37", label: "37 - Ft. Bend West" },
  { value: "38", label: "38 - Ft. Bend East" },
  { value: "39", label: "39 - Montgomery County NW" },
  { value: "40", label: "40 - Montgomery County SE" },
  { value: "41", label: "41 - Houston County" },
  { value: "42", label: "42 - Trinity County" },
  { value: "43", label: "43 - Walker County" },
  { value: "44", label: "44 - Polk County" },
  { value: "45", label: "45 - Angelina County" },
  { value: "46", label: "46 - Jasper County" },
  { value: "47", label: "47 - Newton County" },
  { value: "48", label: "48 - Tyler County" },
  { value: "49", label: "49 - Hardin County" },
  { value: "50", label: "50 - Orange County" },
  { value: "51", label: "51 - Jefferson County" },
  { value: "52", label: "52 - Liberty County" },
  { value: "53", label: "53 - Chambers County" },
  { value: "54", label: "54 - Matagorda County" },
  { value: "55", label: "55 - Wharton County" },
  { value: "56", label: "56 - Colorado County" },
  { value: "57", label: "57 - Austin County" },
  { value: "58", label: "58 - Washington County" },
  { value: "59", label: "59 - Burleson County" },
  { value: "60", label: "60 - Grimes County" },
  { value: "61", label: "61 - Brazos County" },
  { value: "62", label: "62 - Madison County" },
  { value: "63", label: "63 - Leon County" },
  { value: "64", label: "64 - San Jacinto County" },
  { value: "65", label: "65 - Calhoun County" },
  { value: "66", label: "66 - Victoria County" },
  { value: "67", label: "67 - Jackson County" },
  { value: "68", label: "68 - Lavaca County" },
  { value: "69", label: "69 - Fayette County" },
  { value: "70", label: "70 - Lee County" },
  { value: "71", label: "71 - Milam County" },
  { value: "72", label: "72 - Robertson County" },
  { value: "73", label: "73 - Limestone County" },
  { value: "74", label: "74 - Freestone County" },
  { value: "75", label: "75 - Anderson County" },
  { value: "76", label: "76 - Cherokee County" },
  { value: "77", label: "77 - Nacogdoches County" },
  { value: "78", label: "78 - San Augustine County" },
  { value: "79", label: "79 - Sabine County" },
  { value: "80", label: "80 - Other - Texas" },
  { value: "81", label: "81 - Other - United States" },
  { value: "82", label: "82 - Other - International" },
  { value: "83", label: "83 - Central Texas" },
  { value: "84", label: "84 - North Texas" },
  { value: "85", label: "85 - South Texas" },
  { value: "86", label: "86 - West Texas" },
  { value: "87", label: "87 - Panhandle" },
];

export const mlsStatusOptions = [
  { value: "", label: "Please Select" },
  { value: 'A', label: 'Active (Available For Sale / For Rent)' },
  { value: 'OP', label: 'Under Contract – OP Option Pending' },
  { value: 'PS', label: 'Under Contract – PS Pending Continue to Show' },
  { value: 'P', label: 'Under Contract – P Pending' },
  { value: 'closd', label: 'Sold/Rented' },
  { value: 'CS', label: 'Coming Soon' }
];

export const mlsStatusLoggedinOptions = [
  { value: "", label: "Please Select" },
  ...mlsStatusOptions.slice(1),
  { value: 'exp', label: 'Expired' },
  { value: 'term', label: 'Terminated' },
  { value: 'with', label: 'Withdrawn' }
];

// Inverse of the inbound `AVAILABILITY_LABEL_TO_VALUE` normalization: convert an
// MLS dropdown code back to the backend `availabilityEnum` label expected by the
// tool input. Only 'A' and 'with' differ from the enum; every other code equals
// its label (keys lowercased for case-insensitive lookup).
const AVAILABILITY_VALUE_TO_LABEL: Record<string, string> = {
  a: "Active",
  with: "WITH",
};

// Map an MLS dropdown status code to the backend availabilityEnum label. Codes
// that already equal their label pass through unchanged.
export function mapStatusCodeToAvailabilityLabel(code: string): string {
  return AVAILABILITY_VALUE_TO_LABEL[code.toLowerCase()] ?? code;
}

export const propertyTypeOptions = [
  { value: 'Single-Family', label: 'Single Family', icon: 'https://content.harstatic.com/media/icons/search/single_family-9@2x.jpg' },
  { value: 'Townhouse/Condo', label: 'Condo', icon: "https://content.harstatic.com/media/icons/search/condo-image2@2x.jpg" },
  { value: 'Acreage', label: 'Acreage', icon: 'https://content.harstatic.com/media/icons/search/condo-image-copy@2x.jpg' },
  { value: 'Mid/Hi-Rise Condo', label: 'Mid/High-Rise', icon: "https://content.harstatic.com/media/icons/search/hi-rise-image@2x.jpg" },
  { value: 'Residential-Lots', label: 'Lots', icon: "https://content.harstatic.com/media/icons/search/hi-rise-image-copy@2x.jpg" },
  { value: 'Multi-Family', label: 'Multi-Family', icon: "https://content.harstatic.com/media/icons/search/single-family-image-copy@2x.jpg" }
];
export const propertyStatusSaleOptions = [
  { value: 'new_entry', label: 'Just Listed', icon: 'https://content.harstatic.com/media/icons/filters/icon_just_listed.svg' },
  { value: 'pricereduced', label: 'Price Reduction', icon: 'https://content.harstatic.com/media/icons/filters/icon_price_reduced.svg' },
  { value: 'Foreclosure', label: 'Foreclosure', icon: 'https://content.harstatic.com/media/icons/filters/icon_foreclosure.svg' },
  { value: 'new_constr2', label: 'New Construction', icon: 'https://content.harstatic.com/media/icons/filters/icon_new_construction.svg' },
  { value: 'open_houses', label: 'Open House', icon: 'https://content.harstatic.com/media/icons/filters/icon_open_house.svg' },
  { value: 'voh_only', label: 'Virtual Open House Only', icon: 'https://content.harstatic.com/media/icons/filters/icon_open_house.svg' },
];
export const propertyStatusRentOptions = [
  ...propertyStatusSaleOptions,
  { value: 'Foreclosure', label: 'Foreclosure' },
];

export const baseAmenitiesLabels: Record<BaseAmenities, string> = {
  "loft": "Loft",
  "area_pool": "Area Pool",
  "areatennis": "Area Tennis",
  "yard": "Yard",
  "garageapt": "Garage Apt / Guest House",
  "sprinkle": "Sprinkler",
  "patiodeck": "Patio / Deck",
  "mediarm": "Media Room",
  "studyrm": "Study Room",
  "spahottub": "Spa / Hot Tub",
  "culdesac": "Cul-De-Sac",
  "corner": "Corner",
  "waterview": "Water View",
  "waterfront": "Waterfront",
  "lake": "Lake",
  "wooded": "Wooded",
  "greenbelt": "Greenbelt",
  "ongolfcourse": "On Golf Course",
  "ingolfcom": "In Golf Community",
  "energy": "Energy Features",
  "greencert": "Green Certification",
  "access": "Controlled Access",
  "wheelchair": "Wheelchair Access",
  "elevator": "Elevator / Elevator Shaft",
  "furnished": "Furnished"
};

export const harAmenitiesLabels: Record<HarAmenities, string> = {
  ...baseAmenitiesLabels,
  "private_pool": "Private Pool",
};

export const toolFilterAmenitiesLabels: Record<ToolFilterAmenities, string> = {
  ...harAmenitiesLabels,
  "no_private_pool": "No Private Pool"
};

export const toolInputAmenitiesLabels: Record<ToolAmenities, string> = {
  ...baseAmenitiesLabels,
  "pool": "Private Pool"
};

export const baseAmenitiesOptions = typedEntries(baseAmenitiesLabels).map(([value, label]) => ({ value, label }));
export const harAmenitiesOptions = typedEntries(harAmenitiesLabels).map(([value, label]) => ({ value, label }));
export const toolFilterAmenitiesOptions = typedEntries(toolFilterAmenitiesLabels).map(([value, label]) => ({ value, label }));
export const toolInputAmenitiesOptions = typedEntries(toolInputAmenitiesLabels).map(([value, label]) => ({ value, label }));

const baseSalePriceLookup = [
  { 'value': '5000', 'label': '$5,000' },
  { 'value': '10000', 'label': '$10,000' },
  { 'value': '15000', 'label': '$15,000' },
  { 'value': '20000', 'label': '$20,000' },
  { 'value': '25000', 'label': '$25,000' },
  { 'value': '30000', 'label': '$30,000' },
  { 'value': '35000', 'label': '$35,000' },
  { 'value': '40000', 'label': '$40,000' },
  { 'value': '45000', 'label': '$45,000' },
  { 'value': '50000', 'label': '$50,000' },
  { 'value': '55000', 'label': '$55,000' },
  { 'value': '60000', 'label': '$60,000' },
  { 'value': '65000', 'label': '$65,000' },
  { 'value': '70000', 'label': '$70,000' },
  { 'value': '75000', 'label': '$75,000' },
  { 'value': '80000', 'label': '$80,000' },
  { 'value': '85000', 'label': '$85,000' },
  { 'value': '90000', 'label': '$90,000' },
  { 'value': '95000', 'label': '$95,000' },
  { 'value': '100000', 'label': '$100,000' },
  { 'value': '105000', 'label': '$105,000' },
  { 'value': '110000', 'label': '$110,000' },
  { 'value': '115000', 'label': '$115,000' },
  { 'value': '120000', 'label': '$120,000' },
  { 'value': '125000', 'label': '$125,000' },
  { 'value': '130000', 'label': '$130,000' },
  { 'value': '135000', 'label': '$135,000' },
  { 'value': '140000', 'label': '$140,000' },
  { 'value': '145000', 'label': '$145,000' },
  { 'value': '150000', 'label': '$150,000' },
  { 'value': '155000', 'label': '$155,000' },
  { 'value': '160000', 'label': '$160,000' },
  { 'value': '165000', 'label': '$165,000' },
  { 'value': '170000', 'label': '$170,000' },
  { 'value': '175000', 'label': '$175,000' },
  { 'value': '180000', 'label': '$180,000' },
  { 'value': '185000', 'label': '$185,000' },
  { 'value': '190000', 'label': '$190,000' },
  { 'value': '195000', 'label': '$195,000' },
  { 'value': '200000', 'label': '$200,000' },
  { 'value': '205000', 'label': '$205,000' },
  { 'value': '210000', 'label': '$210,000' },
  { 'value': '215000', 'label': '$215,000' },
  { 'value': '220000', 'label': '$220,000' },
  { 'value': '225000', 'label': '$225,000' },
  { 'value': '230000', 'label': '$230,000' },
  { 'value': '235000', 'label': '$235,000' },
  { 'value': '240000', 'label': '$240,000' },
  { 'value': '245000', 'label': '$245,000' },
  { 'value': '250000', 'label': '$250,000' },
  { 'value': '255000', 'label': '$255,000' },
  { 'value': '260000', 'label': '$260,000' },
  { 'value': '265000', 'label': '$265,000' },
  { 'value': '270000', 'label': '$270,000' },
  { 'value': '275000', 'label': '$275,000' },
  { 'value': '280000', 'label': '$280,000' },
  { 'value': '285000', 'label': '$285,000' },
  { 'value': '290000', 'label': '$290,000' },
  { 'value': '295000', 'label': '$295,000' },
  { 'value': '300000', 'label': '$300,000' },
  { 'value': '305000', 'label': '$305,000' },
  { 'value': '310000', 'label': '$310,000' },
  { 'value': '315000', 'label': '$315,000' },
  { 'value': '320000', 'label': '$320,000' },
  { 'value': '325000', 'label': '$325,000' },
  { 'value': '330000', 'label': '$330,000' },
  { 'value': '335000', 'label': '$335,000' },
  { 'value': '340000', 'label': '$340,000' },
  { 'value': '345000', 'label': '$345,000' },
  { 'value': '350000', 'label': '$350,000' },
  { 'value': '355000', 'label': '$355,000' },
  { 'value': '360000', 'label': '$360,000' },
  { 'value': '365000', 'label': '$365,000' },
  { 'value': '370000', 'label': '$370,000' },
  { 'value': '375000', 'label': '$375,000' },
  { 'value': '380000', 'label': '$380,000' },
  { 'value': '385000', 'label': '$385,000' },
  { 'value': '390000', 'label': '$390,000' },
  { 'value': '395000', 'label': '$395,000' },
  { 'value': '400000', 'label': '$400,000' },
  { 'value': '450000', 'label': '$450,000' },
  { 'value': '500000', 'label': '$500,000' },
  { 'value': '550000', 'label': '$550,000' },
  { 'value': '600000', 'label': '$600,000' },
  { 'value': '650000', 'label': '$650,000' },
  { 'value': '700000', 'label': '$700,000' },
  { 'value': '750000', 'label': '$750,000' },
  { 'value': '800000', 'label': '$800,000' },
  { 'value': '850000', 'label': '$850,000' },
  { 'value': '900000', 'label': '$900,000' },
  { 'value': '950000', 'label': '$950,000' },
  { 'value': '1000000', 'label': '$1,000,000' },
  { 'value': '1100000', 'label': '$1,100,000' },
  { 'value': '1200000', 'label': '$1,200,000' },
  { 'value': '1300000', 'label': '$1,300,000' },
  { 'value': '1400000', 'label': '$1,400,000' },
  { 'value': '1500000', 'label': '$1,500,000' },
  { 'value': '1600000', 'label': '$1,600,000' },
  { 'value': '1700000', 'label': '$1,700,000' },
  { 'value': '1800000', 'label': '$1,800,000' },
  { 'value': '1900000', 'label': '$1,900,000' },
  { 'value': '2000000', 'label': '$2.0 Mil' },
  { 'value': '2200000', 'label': '$2.2 Mil' },
  { 'value': '2400000', 'label': '$2.4 Mil' },
  { 'value': '2600000', 'label': '$2.6 Mil' },
  { 'value': '2800000', 'label': '$2.8 Mil' },
  { 'value': '3000000', 'label': '$3.0 Mil' },
  { 'value': '3200000', 'label': '$3.2 Mil' },
  { 'value': '3400000', 'label': '$3.4 Mil' },
  { 'value': '3600000', 'label': '$3.6 Mil' },
  { 'value': '3800000', 'label': '$3.8 Mil' },
  { 'value': '4000000', 'label': '$4.0 Mil' },
  { 'value': '4200000', 'label': '$4.2 Mil' },
  { 'value': '4400000', 'label': '$4.4 Mil' },
  { 'value': '4600000', 'label': '$4.6 Mil' },
  { 'value': '4800000', 'label': '$4.8 Mil' },
  { 'value': '5000000', 'label': '$5.0 Mil' },
  { 'value': '5500000', 'label': '$5.5 Mil' },
  { 'value': '6000000', 'label': '$6.0 Mil' },
  { 'value': '6500000', 'label': '$6.5 Mil' },
  { 'value': '7000000', 'label': '$7.0 Mil' },
  { 'value': '7500000', 'label': '$7.5 Mil' },
  { 'value': '8000000', 'label': '$8.0 Mil' },
  { 'value': '8500000', 'label': '$8.5 Mil' },
  { 'value': '9000000', 'label': '$9.0 Mil' },
  { 'value': '9500000', 'label': '$9.5 Mil' },
  { 'value': '10000000', 'label': '$10 Mil' }
];

export const saleMinPriceLookup = [
  { 'value': '1', 'label': 'Greater than $0' },
  ...baseSalePriceLookup,
]

export const saleMaxPriceLookup = [
  ...baseSalePriceLookup,
]

const baseRentPriceLookup = [
  { value: '100', label: '$100' },
  { value: '150', label: '$150' },
  { value: '200', label: '$200' },
  { value: '250', label: '$250' },
  { value: '300', label: '$300' },
  { value: '350', label: '$350' },
  { value: '400', label: '$400' },
  { value: '450', label: '$450' },
  { value: '500', label: '$500' },
  { value: '550', label: '$550' },
  { value: '600', label: '$600' },
  { value: '650', label: '$650' },
  { value: '700', label: '$700' },
  { value: '750', label: '$750' },
  { value: '800', label: '$800' },
  { value: '850', label: '$850' },
  { value: '900', label: '$900' },
  { value: '950', label: '$950' },
  { value: '1000', label: '$1,000' },
  { value: '1050', label: '$1,050' },
  { value: '1100', label: '$1,100' },
  { value: '1150', label: '$1,150' },
  { value: '1200', label: '$1,200' },
  { value: '1250', label: '$1,250' },
  { value: '1300', label: '$1,300' },
  { value: '1350', label: '$1,350' },
  { value: '1400', label: '$1,400' },
  { value: '1450', label: '$1,450' },
  { value: '1500', label: '$1,500' },
  { value: '1550', label: '$1,550' },
  { value: '1600', label: '$1,600' },
  { value: '1650', label: '$1,650' },
  { value: '1700', label: '$1,700' },
  { value: '1750', label: '$1,750' },
  { value: '1800', label: '$1,800' },
  { value: '1850', label: '$1,850' },
  { value: '1900', label: '$1,900' },
  { value: '1950', label: '$1,950' },
  { value: '2000', label: '$2,000' },
  { value: '2050', label: '$2,050' },
  { value: '2100', label: '$2,100' },
  { value: '2150', label: '$2,150' },
  { value: '2200', label: '$2,200' },
  { value: '2250', label: '$2,250' },
  { value: '2300', label: '$2,300' },
  { value: '2350', label: '$2,350' },
  { value: '2400', label: '$2,400' },
  { value: '2450', label: '$2,450' },
  { value: '2500', label: '$2,500' },
  { value: '2600', label: '$2,600' },
  { value: '2700', label: '$2,700' },
  { value: '2800', label: '$2,800' },
  { value: '2900', label: '$2,900' },
  { value: '3000', label: '$3,000' },
  { value: '3500', label: '$3,500' },
  { value: '4000', label: '$4,000' },
  { value: '4500', label: '$4,500' },
  { value: '5000', label: '$5,000' },
  { value: '5500', label: '$5,500' },
  { value: '6000', label: '$6,000' },
  { value: '6500', label: '$6,500' },
  { value: '7000', label: '$7,000' },
  { value: '7500', label: '$7,500' },
  { value: '8000', label: '$8,000' },
  { value: '8500', label: '$8,500' },
  { value: '9000', label: '$9,000' },
  { value: '9500', label: '$9,500' },
  { value: '10000', label: '$10,000' }
];

export const rentMinPriceLookup = [
  ...baseRentPriceLookup,
];

export const rentMaxPriceLookup = [
  ...baseRentPriceLookup,
];